import React from 'react';
import Loading from 'src/components/Loading';
import styles from './AnyJobRunning.scss';
import { useTranslation } from 'react-i18next';

const AnyJobRunning = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <div className={styles.inner}>
        <div className={styles.waiting}>
          <div className={styles.loading}>
            <Loading />
          </div>
          <div className={styles.info}>
            <p className={styles.title}>{t('features.Employees.components.AnyJobRunning.registering_employee_data_via_CSV')}</p>
            <p className="u-mt10">{t('features.Employees.components.AnyApiRunning.cannot_add_or_update_employee_information_while_registration_is_being_processed')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnyJobRunning;
